import { EmailEnvelopeIcon } from '../../components/svg/EmailEnvelopeIcon';

export const OrderLinkIsNotValid = () => {
  return (
    <div>
      <div className="mx-auto mb-[10px] h-auto w-[18rem] m800:mt-[50px] m800:w-[27rem]">
        <EmailEnvelopeIcon />
      </div>
      <div className="mx-auto max-w-[650px] p-[37px] text-denim-15">
        <div className="mb-[20px] text-center text-[32px] font-bold leading-[normal]">
          Oops &mdash; you can only click this link once
        </div>
        <div className="mx-auto max-w-[436px] text-center text-m font-reg leading-[150%]">
          <p>
            We do this to make sure you don’t accidentally pay for an order
            twice.
          </p>
          <p>
            To go back to your checkout or account page,
            <br />
            <b>use the link we sent you in your sign up email.</b>
          </p>
        </div>
      </div>
    </div>
  );
};
